module.exports = __webpack_public_path__ + "icon_ratkaisu.cc37e3ee816f7aa30a32.svg";